module.exports = __webpack_public_path__ + "static/media/hydronomad-3.4d63fc3c.jpg";